<template>
    <BaseFilters
        btn-filter-id="btn-enps-report-filter"
        :useDefaultSearchButton="true"
        @search="onClickSearch"
    >
        <EnpsResearches
            :label="$t('enps.report.enpsResearch')"
            :value.sync="enpsResearches"
        />
        <Departments showLabel :value.sync="departments" />
    </BaseFilters>
</template>
<script>
import BaseFilters from '@/views/components/filters'
import { EnpsResearches, Departments } from '@/views/components/fields'
export default {
    name: 'Filters',
    components: {
        Departments,
        EnpsResearches,
        BaseFilters,
    },
    data() {
        return {
            departments: [],
            enpsResearches: [],
        }
    },
    methods: {
        onClickSearch() {
            const filters = this.getParsedFilters()
            this.$emit('filter', filters)
        },
        getParsedFilters() {
            const getValue = (v) => v.value
            return {
                enpsResearches: this.enpsResearches.map(getValue),
                departments: this.departments.map(getValue),
            }
        },
    },
}
</script>
<style></style>
